module.exports = __webpack_public_path__ + "img/finishImg.39a904b7.svg";